import * as _ from 'lodash';

angular.module("tromanWeb").controller('MeetingEditController', ['$q', 'stateService', '$transition$', 'tromanServer', 'ObjectCache', 'dialogService', 'meetingShared', function ($qservice, stateService, $transition$, tromanServer, ObjectCache, dialogService, meetingShared) {

    let isSaving = false;

    this.canSave = function () {
        if (isSaving) return false;
        if (this.meeting == null) return false;

        return this.form.$dirty;
    };

    this.save = function save() {
        if (!this.canSave()) return;

        this.form.$commitViewValue();
        this.form.$setSubmitted();

        if (this.form.$invalid) return;

        isSaving = true;
        if (this.meeting.Id == null) {
            tromanServer.Meetings.addMeeting({ Meeting: this.meeting })
                .finally(() => isSaving = false)
                .then(rsp => {
                    stateService.forceGo('meeting.details', { meetingId: rsp.result.Id }, { reload: true, location: 'replace' });
                })
                .catch(dialogService.error);
        } else {
            tromanServer.Meetings.updateMeeting({ Meeting: this.meeting })
                .finally(() => isSaving = false)
                .then(() => { stateService.forceReload('meeting'); })
                .catch(dialogService.error);
        }
    };

    this.hardRemove = function hardRemove() {
        if (this.meeting == null || this.meeting.Id == null) return;

        dialogService.confirm(['Radera mötet permanent.', 'Detta kan inte ångras', 'Är du säker?']).then(() => {
            tromanServer.Meetings.hardRemove(this.meeting.Id)
                .then(() => {
                    stateService.forceGo('meetings.regular');
                })
                .catch(err => { dialogService.error(err); });
        });
    };

    this.$onInit = function $onInit() {
        $qservice
            .all({
                organizations: ObjectCache.getOrganizations(meetingShared.meeting.Organization),
                wageCalculations: ObjectCache.getWageCalculations(meetingShared.meeting.WageCalculation),
            })
            .then(result => {
                this.organizations = result.organizations;
                this.wageCalculations = result.wageCalculations;

                let meeting = meetingShared.meeting.clone();

                if (!meeting.Id) {
                    const orgId = $transition$.params().initialOrganizationId;
                    if (orgId != null) {
                        meeting.Organization = _.find(this.organizations, x => x.Id === orgId);

                        meeting.EnableTimereport = !!meeting.Organization?.EnableTimereport;

                        if (meeting.Organization?.WageCalculationId) {
                            meeting.WageCalculation = _.find(this.wageCalculations, x => x.Id === meeting.Organization.WageCalculationId);
                        } else {
                            meeting.WageCalculation = null;
                        }
                    }
                }

                this.isAdding = !meeting.Id;
                this.meeting = meeting;

                stateService.guard(() => this.form.$dirty);
            })
            .catch(dialogService.error);
    };
}]);
